import { useContext, useMemo } from 'react';
import { AuthContext } from '../../contexts';
/**
 * Returns select options for the IDPs configured on the current workspace entity.
 *
 * Reads from `entity.configuration.idps` in AuthContext. Use this in admin/management
 * UIs (user invite, user edit, site user creation) where all entity IDPs should be
 * available for assignment. Do NOT use this in the login flow — the login flow reads
 * filtered IDPs from the `checkUsername` response instead.
 */
export const useWorkspaceIdpOptions = () => {
    const { entity } = useContext(AuthContext);
    // Derive a stable primitive signature so the memo only recomputes when IDP
    // keys actually change, not on every entity object reference change.
    const idpSignature = entity?.configuration?.idps?.map((idp) => idp.key).join(',') ?? '';
    return useMemo(() => {
        const enabledIdps = (entity?.configuration?.idps ?? []).filter((idp) => idp.enabled);
        const idpOptions = enabledIdps.map((idp) => ({
            value: idp.key,
            label: idp.displayName || idp.name,
        }));
        return {
            idpOptions,
            showIdpSelect: idpOptions.length > 0,
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idpSignature]);
};
/** @deprecated Use `useWorkspaceIdpOptions` instead. */
export const useIdpSelectOptions = useWorkspaceIdpOptions;
